// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** British Indian Ocean Territory */
const IO = /^(?:38\d{5})$/;

export default IO;
